<template>
  <div id="wp_dashboard">
    <h3>WordPress</h3>
    <div class="backdrop" v-if="loading">
      <moon-loader :loading="loading" size="21px" color="#007bff" />
    </div>
    <div class="row">
      <div class="outer-box">
        <h4>WordPress Details</h4>
        

        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Enter Location ID"
            v-model="locationId"
          />   
          <p class="mt-2 text-center">Deleted Site Info is available only for sites deleted after April 22, 2025</p>       
        </div>        
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="getWordpressDetails()"
            :disabled="loading || locationId?.trim() == ''"
          >
            <span>Get WordPress Details </span>
          </button>
        </div>
        <div class="wp-listings" v-if="wordpressDetails != null && wordpressDetailsError === null">
          <div v-for="wpsite in sortedWordpressDetails" :key="wpsite?._id">
            <div class="wp_details">
              <h4 v-if="wordpressDetails.message">
                {{ wordpressDetails.message }}
              </h4>
              <table>
                <!-- <tr>
                  <td>Company ID</td>
                  <td>
                    {{ locationCompanyId }}
                  </td>
                </tr> -->   
                <tr v-if="wpsite?.deleted" style="background: #dc3545 !important;">
                  <td class="text-white">Deleted</td>
                  <td class="text-white">True 
                  </td>
                </tr>             
                <tr v-if="wpsite?.siteId">
                  <td>Site Id</td>
                  <td>{{ wpsite?.siteId }}</td>
                </tr>
                <tr v-if="wpsite?.siteId">
                  <td>Site Title</td>
                  <td>{{ wpsite?.wpTitle }}</td>
                </tr>
                <tr v-if="wpsite?.domain">
                  <td>Primary Domain</td>
                  <td>
                    <a
                      :href="`https://${wpsite?.domain}`"
                      target="_blank"
                      >{{ wpsite?.domain }}</a
                    >
                  </td>
                </tr>
                <tr v-if="wpsite?.domains?.length">
                  <td class="sub_domain">Sub Domains</td>
                  <td>
                    <div v-if="
                      wpsite?.domains &&
                      wpsite?.infra === 'STAR_SHIP'">
                      <div
                        v-for="eachDomain of wpsite?.domains"
                        v-bind:key="eachDomain"
                        v-if="eachDomain.domain !== wpsite?.domain"
                      >
                        <a :href="`https://${eachDomain?.domain}`" target="_blank">{{
                          eachDomain?.domain
                        }}</a>
                      </div>
                    </div>
                    <div v-else-if="wpsite?.subDomains">
                      <div
                        v-for="eachDomain of wpsite?.subDomains"
                        v-bind:key="eachDomain"
                      >
                        <a :href="`https://${eachDomain}`" target="_blank">{{
                          eachDomain
                        }}</a>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr  v-if="wpsite?.staging?.stagingDomain">
                  <td>Staging Domains</td>
                  <td>
                    <div>
                      <span v-if="wpsite?.staging?.stagingDomain">
                        <a
                          :href="
                            wpsite?.staging?.stagingDomain.startsWith(`http`)
                              ? wpsite?.staging?.stagingDomain
                              : `https://${wpsite?.staging?.stagingDomain}`
                          "
                          target="_blank"
                          >{{ wpsite?.staging?.stagingDomain }}</a
                        ></span>
                      </div>
                  </td>
                </tr>
                <tr>
                  <td>Purchase Date</td>
                  <td
                    v-if="wpsite?.createdAt
                    "
                  >
                    {{
                      moment(toMoment(wpsite?.createdAt)).format(
                        "YYYY-MMM-DD HH:mm"
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Days passed</td>
                  <td
                    v-if="wpsite?.createdAt
                    "
                  >
                    <span
                      >{{
                        moment().diff(
                          moment(toMoment(wpsite?.createdAt)),
                          "days"
                        )
                      }}
                      Days</span
                    >
                  </td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>{{ wpsite?.paymentStatus !== 'COMPLETE' ? 'PENDING' : wpsite?.paymentStatus }}</td>
                </tr>
                <tr>
                  <td>Subscription Id</td>
                  <td>{{ wpsite?.subscriptionId }}</td>
                </tr>                
                <tr v-if="wpsite?.wpId">
                  <td>WP Id</td>
                  <td>{{ wpsite?.wpId }}</td>
                </tr>                
                <tr v-if="wpsite?.events?.filter(e => e.event === 'SITE_DELETED')?.length">
                  <td colspan="2">
                    <div class="inner-table-records">
                      <div style="font-size: 14px;" class="text-center text-white bg-primary p-1 font-weight-bold">Deleted Site Info</div>
                      <table>
                        <thead>
                          <tr style="font-size: 13px;">
                            <th style="width: 120px;">WP Id</th>
                            <th>Domain</th>
                            <th style="width: 140px;">Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="event in sortedWordPressEvents(wpsite)" 
                              :key="event.meta.wpId">
                            <td style="width: 120px;">
                              {{ event.meta.wpId }}
                            </td>
                            <td>
                              {{ event.meta.domain || '-' }}
                            </td>
                            <td style="width: 140px;">
                              {{ moment(toMoment(event.meta.dateUpdated)).format("YYYY-MMM-DD HH:mm") }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div v-else-if="wordpressDetailsError">
          <p class="success free-space">
            {{ wordpressDetailsError }}
          </p>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="outer-box">
        <h4>Domain Details</h4>
        <div class="inner-box" style="text-align: left; width: 95%; min-width: 600px;">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="example.com or subdomain.example.com"
            v-model="domainName"
          />
        </div>
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="fetchDomainDetails()"
            :disabled="loading || !domainName?.trim()"
          >
            <span>Fetch Domain Details</span>
          </button>
        </div>
        <div class="wp-domain" v-if="domainDetails && !domainError">
          <div class="wp_details">
            <table>
              <tr v-if="domainDetails?.locationId">
                <td>LocationId Id</td>
                <td>{{ domainDetails?.locationId }}</td>
              </tr>
              <tr v-if="domainDetails?.companyId">
                <td>Agency Id</td>
                <td>{{ domainDetails?.companyId }}</td>
              </tr>
              <tr v-if="domainDetails?.siteId">
                <td>Site Id</td>
                <td>{{ domainDetails?.siteId }}</td>
              </tr>
              <tr v-if="domainDetails?.wpId">
                <td>WP Id</td>
                <td>{{ domainDetails?.wpId }}</td>
              </tr>  
              <tr v-if="domainDetails?.subscriptionId">
                <td>Subscription Id</td>
                <td>{{ domainDetails?.subscriptionId || '-' }}</td>
              </tr>
              <tr>
                <td>Payment Status</td>
                <td>{{ domainDetails?.paymentStatus || '-' }}</td>
              </tr>            
              <tr v-if="domainDetails?.defaultDomain">
                <td>Default Domain</td>
                <td>{{ domainDetails?.defaultDomain === true ? 'Yes' : 'No' }}</td>
              </tr>
              <tr v-if="!domainDetails?.defaultDomain">
                <td>Main Domain</td>
                <td>{{ domainDetails?.mainDomain === true ? 'Yes' : 'No' }}</td>
              </tr>
              <tr v-if="!domainDetails?.defaultDomain">
                <td>Primary Domain</td>
                <td>{{ domainDetails?.primary === true ? 'Yes' : 'No' }}</td>
              </tr>        
              <tr v-if="!domainDetails?.defaultDomain">
                <td>SSL Status</td>
                <td>                  
                  <div v-if="domainDetails?.sslStatus">
                    {{ domainDetails?.sslStatus === 'ACTIVE' ? 'Active' : 'Pending' }}
                  </div>
                </td>
              </tr>          
              <tr v-if="!domainDetails?.defaultDomain">
                <td>DNS Status</td>
                <td>
                  <div>
                    {{ domainDetails?.verified && domainDetails?.pointed ? 'Complete' : 'Pending' }}
                  </div>
                </td>
              </tr>
              <tr v-if="domainDetails?.records?.length" style="font-size: 15px;">
                <td colspan="2">
                  <div class="inner-table-records">
                    <table>
                      <thead>
                        <tr style="font-size: 13px;">
                          <th>Type</th>
                          <th>Name</th>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="record in domainDetails.records" 
                            :key="record.type + record.name">
                          <td>
                            <strong>{{ record.type.toUpperCase() === 'ARECORD' ? 'A' : record.type.toUpperCase() }}</strong>
                          </td>
                          <td :style="record.type === 'txt' ? 'font-size: 14px;' : ''">{{ record.name }}</td>
                          <td :style="record.type === 'txt' ? 'font-size: 14px;' : ''">{{ record.value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
              <tr v-if="domainDetails?.dnsProvider">
                <td>DNS Provider</td>
                <td>
                  <div>
                    {{ domainDetails?.dnsProvider }}
                  </div>
                </td>
              </tr>  
              <tr>
                <td>Created</td>
                <td v-if="domainDetails?.createdAt">
                  {{ moment(toMoment(domainDetails?.createdAt)).format("YYYY-MMM-DD HH:mm") }}
                </td>
              </tr>
              <tr v-if="domainDetails?.sslStatus === 'ACTIVE' && domainDetails?.verified && domainDetails?.pointed">
                <td>Verified</td>
                <td v-if="domainDetails?.dnsCheckedAt">
                  {{ moment(toMoment(domainDetails?.dnsCheckedAt)).format("YYYY-MMM-DD HH:mm") }}
                </td>
              </tr>           
            </table>
          </div>
        </div>
        <div v-else-if="domainError">
          <p class="error free-space">
            {{ domainError }}
          </p>
        </div>
      </div>
    </div>

    <!--<div class="row">
      <div class="outer-box">
        <h4>Reset WordPress</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap free-space"
            type="text"
            placeholder="Enter Location ID"
            v-model="locationId"
          />
          <p>
            This will change the state to the new installation (next step after
            payment is processed). Domain , Subdomains details will be
            permanently removed, make a note before proceeding
          </p>
        </div>
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="resetWp()"
            :disabled="loading || locationId.trim() == ''"
          >
            <span> Reset WordPress </span>
          </button>
          <p class="success free-space" v-if="resetWpDetails">
            {{ resetWpDetails }}
          </p>
        </div>
      </div>
    </div>-->
    <div class="row">
      <!-- <div class="outer-box">
        <h4>Unsubscribe WordPress</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap m-1"
            type="text"
            placeholder="Enter Location ID"
            v-model="locationId"
            @keypress="resetUnsubscribeForm"
          />

          <input
            class="hl_input--wrap m-1"
            type="text"
            placeholder="Enter Site ID"
            v-model="siteId"
            @keypress="resetUnsubscribeForm"
          />
          <div class="checklist">
            <ol>
              <li>
                Infra Cleared i.e ALL Data & Websites will be deleted
              </li>
              <li>
                Stripe Unsubscribed from Location
              </li>
              <li>
                Status updated on our db (Location)
              </li>
              <li>
                Stripe Unsubscribed from Agency
              </li>
              <li>
                Status updated on our db (Agency)
              </li>
            </ol>
          </div>
          <p v-if="responseStatus && responseStatus.error_message" class="error text-center">
            {{ responseStatus.error_message }}
          </p>
          <p v-if="responseStatus && responseStatus.success_message" class="success text-center">
            {{ responseStatus.success_message }}
          </p>

          <button
            class="btn btn-primary unsub-btn"
            @click="showUnsubscribeModal()"
            :disabled="loading || locationId?.trim() === '' || siteId?.trim() === ''"
          >
            <span>Unsubscribe WordPress</span>
          </button>
        </div>
      </div> -->

      <!-- Modal - Confirmation for Unsubscribe WordPress -->
      <!-- <modal v-if="unsubscribeModal" class="modal-popup" @close="closeUnsubscribeModal()">
        <div class="modal-content">
          <div class="modal-header">
            <div></div>
            <div class="modal-title text-dark">Unsubscribe WordPress</div>
            <i class="fa fa-times modal-close-icon" @click="closeUnsubscribeModal()" />
          </div>
          <div class="modal-body form-set-status">

            <div class="form-info">
              <div>
                <div class="font-weight-bold mb-1">Are you sure you want to Unsubscribe WordPress?</div>
                <b-alert show variant="danger">
                  Be aware that unsubscribing WordPress is an irreversible process. It is essential to understand that once initiated, this action will permanently delete all data related to the WordPress site and its subscriptions. There will be no option for content recovery after this final step.
                </b-alert>
              </div>
              <div>
                <div class="mb-1">Confirm by typing <span class="error font-weight-bold">Unsubscribe</span> below</div>
                <input
                  type="text"
                  placeholder="Unsubscribe"
                  v-model="confirmDelete"
                />
              </div>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn modal-action-btn" @click="closeUnsubscribeModal()">Cancel</button>
            <button
              class="btn btn-danger modal-action-btn"
              @click="unsubListing()"
              :disabled="confirmCompare(confirmDelete, 'Unsubscribe')"
            >
            <span>Proceed</span>
            </button>
          </div>
        </div>
      </modal> -->
    </div>
    <div class="row">
      <div class="outer-box">
        <h4>Hide WordPress offer for all Locations</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap free-space"
            type="text"
            placeholder="Agency Company ID"
            v-model="agencyCompanyId"
          />
          <p>
            This action will disable the WordPress offering for all subaccounts in agencies where a valid WordPress subscription is not present.
          </p>

          <!-- <p>
            ( To find the Company ID ( Not Relationship No ) enter any one sub-account ID of the agency in the get wordpress details section and it will give you the company ID )
          </p> -->
        </div>
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="showDisableConfirmModal()"
            :disabled="loading || agencyCompanyId?.trim() == ''"
          >
            <span> Disable WordPress Offering </span>
          </button>
          <p class="success free-space" v-if="disableWpDetails">
            {{ disableWpDetails }}
          </p>
        </div>
      </div>
    </div>
    <!-- Modal - Confirmation for Hide WordPress offer for all Locations -->
    <modal v-if="disableOfferingConfirmModal" class="modal-popup disableOffering" @close="closeDisableConfirmModal()">
        <div class="modal-content">
          <div class="modal-header">
            <div></div>
            <div class="modal-title text-dark">Disable WordPress Offering</div>
            <i class="fa fa-times modal-close-icon" @click="closeDisableConfirmModal()" />
          </div>
          <div class="modal-body form-set-status">

            <div class="form-info">
              <div>
                <div class="font-weight-bold mb-1">Are you sure you want to disable WordPress offering?</div>
                <!-- <b-alert show variant="danger">
                  Be aware that disable WordPress offering .....
                </b-alert> -->
              </div>
              <div>
                <div class="mb-1">Confirm by typing <span class="error font-weight-bold">Disable</span> below</div>
                <input
                  type="text"
                  placeholder="Disable"
                  v-model="confirmDelete"
                />
              </div>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn modal-action-btn" @click="closeDisableConfirmModal()">Cancel</button>
            <button
              class="btn btn-danger modal-action-btn"
              @click="disableAllWordpress()"
              :disabled="confirmCompare(confirmDelete, 'Disable')"
            >
            <span>Proceed</span>
            </button>
          </div>
        </div>
      </modal>
    <!-- <div class="row">
      <div class="outer-box">
        <h4>Change Location Subscription to STANDARD Plan</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap free-space"
            type="text"
            placeholder="Location Id"
            v-model="locationId"
          />
          <p>
            This will change the location subscription to STANDARD plan
            $10/month (only if they are in some special plan)
          </p>
        </div>
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="switchToStandardPlan()"
            :disabled="!locationId || locationId.trim() == ''"
          >
            <span> Switch to Standard Plan </span>
          </button>
          <p
            :class="{
              'free-space': true,
              success: switchToStandardPlanResult.success,
              error: !switchToStandardPlanResult.success,
            }"
            v-if="
              switchToStandardPlanResult && switchToStandardPlanResult.message
            "
          >
            {{ switchToStandardPlanResult.message }}
          </p>
        </div>
      </div>
    </div> -->
    <!-- <div class="row">
      <div class="outer-box">
        <h4>Cancel Agency Special Subscription</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap free-space"
            type="text"
            placeholder="Relationship Number"
            v-model="relationShipNumber"
          />
          <p>
            This will cancel agency special plans like Unlimited Monthly/Yearly
            etc.
          </p>
        </div>
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="cancelSpecialAgencyPlan()"
            :disabled="!relationShipNumber || relationShipNumber?.trim() == ''"
          >
            <span> Cancel Agency Plan </span>
          </button>
          <p
            :class="{
              'free-space': true,
              success: cancelAgencyPlan.success,
              error: !cancelAgencyPlan.success,
            }"
            v-if="cancelAgencyPlan && cancelAgencyPlan.message"
          >
            {{ cancelAgencyPlan.message }}
          </p>
          <div v-if="cancelAgencyPlan.nonCompliantLocations" class="free-space">
            <div
              v-for="eachNonCompliantLocation of cancelAgencyPlan.nonCompliantLocations"
              v-bind:key="eachNonCompliantLocation.locationId"
            >
              {{ eachNonCompliantLocation.locationName }} -
              {{ eachNonCompliantLocation.locationId }}
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="row">
      <div class="outer-box">
        <h4>Change Company to Unlimited Monthly Plan</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap free-space"
            type="text"
            placeholder="Company / Agency Id"
            v-model="companyId"
          />
          <p>
            This will change the company Standard plan ($10/month) to Unlimited
            Monthly plan ($350/month)
          </p>
        </div>
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="switchStandardToUnlimitedMonthlyPlan()"
            :disabled="!companyId || companyId?.trim() == ''"
          >
            <span> Switch to Unlimited Monthly Plan </span>
          </button>
          <p
            :class="{
              'free-space': true,
              success: switchStandardToMonthlyPlanResult.success,
              error: !switchStandardToMonthlyPlanResult.success,
            }"
            v-if="
              switchStandardToMonthlyPlanResult &&
              switchStandardToMonthlyPlanResult.message
            "
          >
            {{ switchStandardToMonthlyPlanResult.message }}
          </p>
        </div>
      </div>
    </div> -->

    <!-- <div class="row">
      <div class="outer-box">
        <h4>Pause subscription for Stripe change</h4>
        <div class="inner-box" style="text-align: left; width: 600px">
          <input
            class="hl_input--wrap free-space"
            type="text"
            placeholder="Agency Relationship Number"
            v-model="relationShipNumber"
          />
          <p
            v-if=" stripePauseResponse &&
                    stripePauseResponse.status"
            :class="[this.stripePauseResponse.status, 'center text-center']"
          >
            {{ this.stripePauseResponse.message }}
          </p>
          <button
            class="btn btn-primary unsub-btn"
            @click="pauseSubscriptionForStripeChange()"
            :disabled="loading || relationShipNumber?.trim() == ''"
          >
            <span>Pause subscriptions</span>
          </button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { SaasService, WordpressService } from "@/services";
import Modal from '../common/Modal.vue';
import * as moment from "moment";

export default {
  components: {
    Modal,
  },
  data: function () {
    return {
      moment,
      loading: false,
      locationId: "",
      companyId: "",
      siteId: "",
      error: "",
      responseStatus: null,
      wordpressDetails: null,
      stagingUrl: "",
      manualMigrationStatus: null,
      userCreationDetails: null,
      ignoreStripeStatus: false,
      resetWpDetails: null,
      disableWpDetails: null,
      switchToStandardPlanResult: {
        success: false,
        message: null,
      },
      relationShipNumber: "",
      agencyCompanyId: "",
      cancelAgencyPlan: {
        success: false,
        message: null,
      },
      switchStandardToMonthlyPlanResult: {
        success: false,
        message: null,
      },
      wordpressInfra: null,
      wpId: null,
      unsubscribeModal: false,
      confirmUnsubscribe: false,
      confirmDelete: '',
      stripePauseResponse: null,
      locationCompanyId: null,
      wordpressDetailsError: null,
      disableOfferingConfirmModal: false,
      domainName: "",
      domainDetails: null,
      domainError: null,
    };
  },
  computed: {
    sortedWordpressDetails() {
      return [...this.wordpressDetails].sort((a, b) => {
        // First sort by deleted status (false comes first)
        if (a.deleted !== b.deleted) {
          return a.deleted ? 1 : -1;
        }
        // Then sort by createdAt date
        return moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf();
      });
    },
    sortedWordPressEvents() {
      return (wpsite) => {
        return [...wpsite.events.filter(e => e.event === 'SITE_DELETED')].sort((a, b) => {
          // Sort by wpsite.deleted status (false comes first)
          return wpsite.deleted ? 1 : -1;
        }).reverse();
      };
    }
  },
  methods: {
    toMoment(fsDate) {
      let date = moment();
      if (fsDate && fsDate._seconds) {
        date = moment.unix(fsDate._seconds);
      } else if (typeof fsDate === "string") {
        date = moment(fsDate);
      }
      return date;
    },
    // async unsubListing() {
    //   return false;
    //   this.unsubscribeModal = false;
    //   this.loading = true;
    //   this.error = "";
    //   this.responseStatus = null;
    //   try {
    //     let queryParam = new URLSearchParams({
    //       ignore_stripe_errors: this.ignoreStripeStatus,
    //     });
    //     this.loading = true;
    //     let instanceCleared = false;
    //     let success_message = ''
    //     let error_message = ''

    //     try {
    //         let response = "";
    //         if (this.locationId && this.siteId) {
    //             response = await WordpressService.unsubscribeWordpressBySiteId(this.locationId, this.siteId);
    //         } else {
    //             instanceCleared = false;
    //             error_message = "Missing locationId or siteId";
    //         }

    //         if (response && (response.status === 200 || response.status === 201) && response?.data?.success === true) {
    //             instanceCleared = true;
    //             success_message = response?.data?.message || "Unsubscribed Successfully.";
    //         } else {
    //             instanceCleared = false;
    //             error_message = response?.data?.message || "Failed to get WordPress details for Location ID:"+this.locationId+" & Site ID:"+this.siteId+"";
    //         }

    //     } catch (err) {
    //         instanceCleared = false;
    //         error_message = `Error: ${err.message}`;
    //         console.error(err); // Logging the error for debugging
    //     }

    //     if (instanceCleared) {
    //         this.responseStatus = {
    //             infra_cleanup: true,
    //             location_unsubscribed: true,
    //             location_db_update: true,
    //             agency_unsubscribed: true,
    //             agency_db_update: true,
    //             success_message: success_message,
    //         };
    //     } else {
    //         this.responseStatus = {
    //             infra_cleanup: false,
    //             location_unsubscribed: false,
    //             location_db_update: false,
    //             agency_unsubscribed: false,
    //             agency_db_update: false,
    //             error_message: error_message,
    //         };
    //     }

    //     this.loading = false;
    //   } catch (err) {
    //     console.error(err);
    //     this.loading = false;
    //     this.error = err.response.data.message;
    //   }
    // },

    async getWordpressDetails() {
      this.loading = true;
      this.wordpressDetails = null;
      this.wordpressDetailsError = null;
      try {
        const wpDetails = await WordpressService.getWordpressDetails(this.locationId);
        if(wpDetails?.data) {
          this.loading = false;
          this.wordpressDetails = wpDetails?.data?.result
          for (const detail of this.wordpressDetails) {
            try {              
              const primaryDomain = await WordpressService.getPrimaryDomain(this.locationId, detail.wpId)
              detail.domain = primaryDomain?.data?.domain || detail?.domain
            } catch {}
          }
        } 
        if(!this.wordpressDetails?.length){
          this.wordpressDetailsError = `No WordPress installations found for location ${this.locationId}`;
        }
      } catch (error) {
        this.wordpressDetailsError = `Failed to fetch WordPress details for ${this.locationId}`;
        console.error("Failed to fetch WordPress details:", error);
      }
      this.loading = false;
    },

    // async getWordpressInfra() {
    //   this.wordpressInfra = null;
    //   this.wpId = null;
    //   const res  =  await WordpressService.getWordpressDetails(this.locationId)
    //     .catch((err) => {
    //       console.error(err);
    //     });

    //   this.wordpressInfra = res.data.infra;
    //   this.wpId  = res.data.wpId;

    //   return true;
    // },

    // async resetWp() {
    //   this.loading = true;
    //   await this.getWordpressInfra();
    //   let apiResponse = Promise.resolve();
    //   if(this.wpId != null) {
    //     WordpressService.clearWordpressInstance(this.locationId)
    //     .then((res) => {
    //       this.loading = false;
    //       this.resetWpDetails = "WordPress installation cleared";
    //     })
    //     .catch((err) => {
    //       if (
    //         err?.response?.status == 400 &&
    //         (
    //           err?.response?.data?.message
    //           .toLowerCase()
    //           .includes("no wordpress installation found") || err?.response?.data?.type === 'SITE_DELETED'
    //         )
    //       ) {
    //         this.resetWpDetails = "WordPress installation cleared";
    //       }

    //       this.loading = false;
    //     });

    //   } else {
    //       this.loading = false;
    //       this.resetWpDetails = "WordPress installation cleared";
    //   }
    // },

    async disableAllWordpress() {
      // When switching to revex backend remember to switch relationship no to firestore
      this.loading = true;
      this.disableWpDetails = null;
      try {
        let response = await WordpressService.disableWordpressForAllLocations({
          companyId: this.agencyCompanyId,
        });
        this.disableWpDetails = response.data.message;
      } catch (err) {
        this.disableWpDetails = err.message || "Unable to update";
      }
      this.loading = false;
      this.closeDisableConfirmModal()
    },

    // async switchToStandardPlan() {
    //   try {
    //     this.loading = true;
    //     this.switchToStandardPlanResult = null;
    //     const result = await SaasService.switchToStandardWordpressPlan({
    //       locationId: this.locationId,
    //       overrideSpecialPlan: true,
    //     });
    //     this.switchToStandardPlanResult = {
    //       success: result.data.success,
    //       message: result.data.message,
    //     };
    //   } catch (err) {
    //     this.switchToStandardPlanResult = {
    //       success: err.response.data.success,
    //       message: err.response.data.message,
    //     };
    //   }
    //   this.loading = false;
    // },

    // async cancelSpecialAgencyPlan() {
    //   try {
    //     this.loading = true;
    //     this.cancelAgencyPlan = {
    //       success: false,
    //       message: null,
    //       nonCompliantLocations: null,
    //     };
    //     const result = await SaasService.cancelSpecialWordpressPlan({
    //       relationshipNumber: this.relationShipNumber,
    //     });
    //     this.cancelAgencyPlan = {
    //       success: result.data.success,
    //       message: result.data.message,
    //     };
    //   } catch (err) {
    //     this.cancelAgencyPlan = {
    //       success: err.response.data.success,
    //       message: err.response.data.message,
    //       nonCompliantLocations: err.response.data.nonCompliantLocations,
    //     };
    //   }
    //   this.loading = false;
    // },

    // async switchStandardToUnlimitedMonthlyPlan() {
    //   try {
    //     let response = "";
    //     response = await WordpressService.switchToUnlimitedMonthlyWordpressPlan({
    //       companyId: this.companyId
    //     });

    //     if (response.status === 201) {
    //       this.switchStandardToMonthlyPlanResult.success = true;
    //       this.switchStandardToMonthlyPlanResult.message =
    //         "Subscribed to Unlimited Monthly Plan.";
    //     }
    //   } catch (err) {
    //     console.log(err);
    //     this.switchStandardToMonthlyPlanResult.success = false;
    //     this.switchStandardToMonthlyPlanResult.message =
    //       "Request Failed - Invalid Company / Agency ID";
    //   }
    // },

    // async pauseSubscriptionForStripeChange() {
    //   this.loading = true;
    //   this.error = "";
    //   this.stripePauseResponse = null;
    //   try {
    //       const saasRes = await SaasService.markWordpressUnsubscribeForStripe({
    //         relationship_number: this.relationShipNumber
    //       });
    //       this.stripePauseResponse = saasRes.data
    //     this.loading = false;
    //   } catch (err) {
    //     console.error(err);
    //     this.loading = false;
    //     if (
    //       err &&
    //       err.response &&
    //       err.response.data &&
    //       err.response.data.message
    //     ) {
    //       this.error = err.response.data.message;
    //     } else {
    //       this.error = err.message || err;
    //     }
    //   }
    // },

    // showUnsubscribeModal() {
    //   this.error = '';
    //   this.unsubscribeModal = true
    //   this.confirmDelete = ''
    // },
    // closeUnsubscribeModal() {
    //   this.unsubscribeModal = false
    //   this.confirmDelete = ''
    // },

    // confirmCompare(compareString, compareWith) {
    //   const confirm = compareWith.localeCompare(compareString, undefined, { sensitivity: 'base' })
    //   return confirm == 0 ? false : true;
    // },
    // resetUnsubscribeForm() {
    //   this.responseStatus = null;
    // },

    showDisableConfirmModal() {
      this.error = '';
      this.disableOfferingConfirmModal = true
      this.confirmDelete = ''
    },
    closeDisableConfirmModal() {
      this.disableOfferingConfirmModal = false
      this.confirmDelete = ''
    },
    confirmCompare(compareString, compareWith) {
      const confirm = compareWith.localeCompare(compareString, undefined, { sensitivity: 'base' })
      return confirm == 0 ? false : true;
    },
    async fetchDomainDetails() {
      this.loading = true;
      this.domainDetails = null;
      this.domainError = null;

      // Clean the domain input
      const cleanDomain = this.domainName
        .trim()
        .toLowerCase()
        .replace(/^(https?:\/\/)?(www\.)?/i, '')  // Remove http://, https://, www.
        .replace(/\/+$/, '')                       // Remove trailing slashes
        .split('/')[0];                           // Take only the domain part

      if (!cleanDomain) {
        this.domainError = "Please enter a valid domain name";
        this.loading = false;
        return;
      }

      try {
        const response = await WordpressService.fetchDomainDetails(cleanDomain);
        if(response?.data?.success) {
          this.loading = false;
          this.domainDetails = response.data.data;
        } 
        if(!this.domainDetails) {
          this.domainError = `No domain details found for ${cleanDomain}`;
        }
      } catch (error) {
        this.domainError = `Failed to fetch domain details for ${cleanDomain}`;
        console.error("Failed to fetch domain details:", error);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#wp_dashboard {
  position: relative;
  .checklist {
    padding: 20px;
  }

  .unsub-btn {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 10px;
    margin: auto;
  }
  .error {
    color: #e53716;
    font-style: italic;
  }
  .warn {
    color: #ffc107;
  }
  .success {
    color: #28a745;
    font-style: italic;
    margin: 10px;
    color: #fff;
  }
  .wp-listings {
    max-height: 400px;
    overflow: auto;
    margin: 10px 0;
    padding: 0 15px;
    border: 1px dotted #e9e9e9;
  }
  .domain-listings {
    max-height: 100%;
    overflow: auto;
    margin: 10px 0;
    padding: 0 15px;
    border: 1px dotted #e9e9e9;
  }
  .wp_details {
    width: 100%;
    max-width: 100%;
    text-align: left;
    display: grid;
    justify-content: stretch;
    grid-gap: 20px;
    padding-top: 15px;
    padding-bottom: 15px;
    table {
      width: 100%;
      padding: 0 15px;
      .sub_domain {
        vertical-align: top;
      }
      border: 1px solid #e9e9e9;
      tr:first-child {
        background: #eff4ff !important;
      }
      tr {
        td {
          padding: 5px 10px;
        }
        td:first-child {
        }
        td:last-child {
          color: #4e4c4c;
        }
      }
      tr:nth-child(odd) {
        background: #f5f5f582;
      }
    }

    .inner-table-records {
      max-height: 100%;
      overflow-y: auto;
      margin: 5px 0;
      border-radius: 6px;
      padding-bottom: 15px;
      box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
      background: #f8f9fa;
      
      table {
        width: 100%;
        border-collapse: collapse;
        
        th {
          background: #f8f9fa;
          padding: 8px;
          text-align: left;
          font-weight: 600;
          position: sticky;
          top: 0;
          z-index: 1;
        }
        
        td {
          padding: 6px 8px;
          border-bottom: 1px solid #eee;
          font-size: 0.95em;
          word-break: break-all;
          background: #eff4ff;
        }

        th:first-child,
        td:first-child {
          width: 80px;
        }

        th:nth-child(2),
        td:nth-child(2) {
          width: 200px;
        }
      }
    }
  }

  .backdrop {
    position: fixed;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ffffffa1;
    z-index: 100;
    display: grid;
    justify-content: center;
    align-items: center;
  }
  .free-space {
    margin: 10px 0;
    max-width: 100%;
    line-break: anywhere;
  }
}

.modal-popup {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);

  ::v-deep(.modal-container) {
    max-width: 520px !important;
  }
  .modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 15px 15px 30px 15px;
    border: 1px solid #888;
    max-width: 640px;
  }

  .modal-header {
    padding: 16px 24px;
    font-size: 20px;
    font-weight: bold;
    background-color: #fafafa;
    color: #575757;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .modal-close-icon {
    cursor: pointer;
    color: #575757;
  }
  .modal-body {
    padding: 30px 15px;
    text-align: left;
  }
  .modal-body > * {
    width: 100%;
    margin-bottom: 10px;
  }
  .modal-body input {
    padding: 10px;
    outline: none;
    border: 1px solid #ddd;
    border-radius: 4px;
    width:100%;
  }
  .modal-body .form-title {
    font-size: 14px;
    position: relative;
  }
  .modal-action-btn {
    width: 46% !important;
    padding: 14px 25px;
    margin: 5px;
    text-align: center;
    outline: none;
    border: none;
    transition: all 0.3s ease;
  }
}
</style>
